  document.addEventListener('DOMContentLoaded', function() {
    const stateSelector = document.getElementById('state-selector-wrapper');
    const dropdownTrigger = document.querySelector('.custom-select__trigger');
    const dropdownMenu = document.getElementById('state-dropdown');
    const searchInput = document.getElementById('state-search-input');
    const selectedDisplay = document.getElementById('selected-state-display');
    const clearBtn = document.getElementById('clear-selection-btn');
    const stockistCards = document.querySelectorAll('.stockist-card');
    const options = document.querySelectorAll('.custom-select__option');
    const stateHide = document.getElementById('selected-state-display');
    let selectedState = '';
    let isOpen = false;
    
    // Hide all stockists initially
    stockistCards.forEach(card => {
      card.style.display = 'none';
    });
    
    // Toggle dropdown
    dropdownTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      isOpen = !isOpen;
      toggleDropdown();
    });
    
    // Search functionality
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase();
      options.forEach(option => {
        const text = option.textContent.toLowerCase();
        if (text.includes(searchTerm)) {
          option.style.display = 'block';
        } else {
          option.style.display = 'none';
        }
      });
    });
    
    // Option selection
    options.forEach(option => {
      option.addEventListener('click', function() {
        selectedState = this.dataset.value;
        selectedDisplay.textContent = selectedState;
        selectedDisplay.style.display = 'block';
        searchInput.style.display = 'none';
        clearBtn.style.display = 'block';
        
        // Close dropdown
        isOpen = false;
        toggleDropdown();
        
        // Filter stockists
        filterStockists(selectedState);
      });
    });
    
    // Clear selection
    clearBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      selectedState = '';
      selectedDisplay.style.display = 'block';
      searchInput.style.display = 'none';
      clearBtn.style.display = 'none';
      searchInput.value = '';
      stateHide.style.display = 'none';
      
      // Show all options
      options.forEach(option => {
        option.style.display = 'block';
      });
      
      // Hide all stockists
      stockistCards.forEach(card => {
        card.style.display = 'none';
      });
    });
    
    // Click outside to close
    document.addEventListener('click', function(e) {
      if (!stateSelector.contains(e.target)) {
        isOpen = false;
        toggleDropdown();
      }
    });
    
    function toggleDropdown() {
      if (isOpen) {
        dropdownMenu.style.display = 'block';
        dropdownTrigger.setAttribute('aria-expanded', 'true');
        stateSelector.classList.add('is-open');
        searchInput.focus();
      } else {
        dropdownMenu.style.display = 'none';
        dropdownTrigger.setAttribute('aria-expanded', 'false');
        stateSelector.classList.remove('is-open');
      }
    }
    
    function filterStockists(state) {
      // Hide all stockists
      stockistCards.forEach(card => {
        card.style.display = 'none';
      });
      
      // Show stockists for selected state
      if (state) {
        const filteredStockists = document.querySelectorAll(`[data-state="${state}"]`);
        filteredStockists.forEach(card => {
          card.style.display = 'block';
        });
      }
    }
  });